import Vue from 'vue';
import MixinConstant from '../mixins/mixin-constant.vue';

import StacaLecture from './components/staca-lecture';
import OnlineLectureLanding from './components/online-lecture-landing';
import OnlineLectureSimple from './components/online-lecture-simple';
import OnlineLectureMembership from './components/online-lecture-membership';
import OnlineLectureTeacher from './components/online-lecture-teacher';

Vue.prototype.$EventBus = new Vue();
Vue.mixin(MixinConstant);

(() => new Vue({
  el: '#App',
  created() {
    if (typeof vue === 'object') {
      vue = this;
    }
  },
  components: {
    'staca-lecture': StacaLecture,
    'online-lecture-landing': OnlineLectureLanding,
    'online-lecture-simple': OnlineLectureSimple,
    'online-lecture-membership': OnlineLectureMembership,
    'online-lecture-teacher': OnlineLectureTeacher,
  },
}))();



// WEBPACK FOOTER //
// ./src/Lecture/Lecture.js